import { render, staticRenderFns } from "./StoreClosures.vue?vue&type=template&id=ddbfb3ae&scoped=true&"
import script from "./StoreClosures.vue?vue&type=script&lang=ts&"
export * from "./StoreClosures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbfb3ae",
  null
  
)

export default component.exports